import { render } from "./PropertyList.vue?vue&type=template&id=03ae3883&scoped=true"
import script from "./PropertyList.vue?vue&type=script&lang=js"
export * from "./PropertyList.vue?vue&type=script&lang=js"

import "./PropertyList.vue?vue&type=style&index=0&id=03ae3883&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ae3883"]])

export default __exports__